import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useEffect, useState } from '@redneckz/uni-jsx/lib/hooks';
import { useForm } from '../../hooks/useForm.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { Button } from '../../ui-kit/Button/Button.js';
import { CurrencyInput } from '../../ui-kit/CurrencyInput/CurrencyInput.js';
import { Heading } from '../../ui-kit/Heading/Heading.js';
import { style } from '../../utils/style.js';
const DEFAULT_TITLE = 'Укажите сумму перевода';
const DEFAULT_LABEL = 'Сумма перевода';
const MAX_AMOUNT = 300000;
const MIN_AMOUNT = 1;
const FORM_URL_MAP = {
    private: 'https://old.rshb.ru/p2p/',
    business: 'https://old.rshb.ru/smallbusiness/p2p/',
};
const INITIAL_FORM_STATE = {
    amount: 1500,
};
export const CardTransfer = JSX(({ className = '', title = DEFAULT_TITLE, label = DEFAULT_LABEL, button, formType = 'private', ...rest }) => {
    const [{ amount }, { field }] = useForm(INITIAL_FORM_STATE);
    const [isDisabled, setDisabled] = useState(false);
    useEffect(() => {
        setDisabled(amount <= 0);
    }, [amount]);
    return (_jsxs(BlockWrapper, { className: style('flex flex-col items-center', className), defaultPadding: "p-6xl", ...rest, children: [title ? (_jsx(Heading, { className: "pb-lg xl:pb-4xl self-start xl:self-center", headingType: "h3", title: title })) : null, _jsxs("form", { className: "w-full xl:max-w-[468px]", method: "POST", action: FORM_URL_MAP[formType], children: [_jsx(CurrencyInput, { valid: !isDisabled, label: label, max: MAX_AMOUNT, min: MIN_AMOUNT, ...field('amount', { parse: Number, format: String }) }), _jsx("input", { type: "hidden", name: "amount", value: amount }), button?.text ? (_jsx(Button, { className: "w-full mt-lg", type: "submit", disabled: isDisabled, children: button.text })) : null] })] }));
});
//# sourceMappingURL=CardTransfer.js.map